import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EventTypeSection from "./EventTypeSection";
import OrganizerDetails from "./OrganizerDetails";
import EventDetails from "./EventDetails";
import ImageUpload from "./ImageUpload";
import { createEvent } from "../../services/eventService";

export default function CreateEvent() {
  const [digitalEvent, setDigitalEvent] = useState(false);
  const [featureEvent, setFeatureEvent] = useState(false);
  const [eventNature, setEventNature] = useState("SINGLE_LOCATION");
  const [eventImages, setEventImages] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const navigate = useNavigate();

const handleSubmit = async (e) => {
 e.preventDefault();
    const formData = new FormData(e.target);
    const cityId = formData.get("cityId");
    const imageList = eventImages.map((url, index) => ({
      id: 0,
      imageUrl: url.url,
      altText: `event-image-${index + 1}`,
      isFeatured: index === 0, // first image as featured
      status: "ACTIVE",
      entityType: "EVENT",
      createdBy: 1,
      description: "",
      mediaType: "IMAGE",
    }));

  const data = {
    digitalEvent,
    featureEvent,
    eventNature,
    eventCategoryId: selectedCategoryId,
    createdBy: 1,
    eventStatus: "ACTIVE",
    ...Object.fromEntries(formData.entries()),
    imageList,
  };

  console.log("Submitted Data:", data);

 try {
     const res = await createEvent(data);

     const eventId = res.data.eventId;

     console.log("Event created successfully:", eventId);

     // redirect to artist page
      navigate(`/create-artist/${eventId}`, {
           state: { eventNature, cityId }
         });


   } catch (error) {
     console.error("Event creation failed:", error);
   }
};

  return (
    <form onSubmit={handleSubmit} className="px-0 py-5">
{/* Breadcrumb */}
<div className="text-xs sm:text-sm mb-4 flex flex-wrap items-center gap-1">
  <span className="text-gray-400">Home /</span>
  <span className="text-black font-medium">Create an Event</span>
</div>

{/* Step Indicator */}
<div className="flex flex-wrap gap-y-6 mb-10">

  {[1, 2, 3, 4].map((step, index) => (
    <div key={step} className="flex items-center">

      {/* Circle */}
      <div
        className={`w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12
        rounded-full flex items-center justify-center
        text-xs sm:text-sm md:text-base font-semibold ${
          step === 1
            ? "bg-yellow-400 text-white"
            : "bg-gray-300 text-white"
        }`}
      >
        {step}
      </div>

      {/* Arrow */}
      {index !== 3 && (
        <div className="flex items-center mx-2 sm:mx-4">
          <div className="w-8 sm:w-12 md:w-16 h-[2px] bg-neutral-400"></div>
          <div className="w-0 h-0
            border-t-[4px] sm:border-t-[5px]
            border-b-[4px] sm:border-b-[5px]
            border-l-[6px] sm:border-l-[8px]
            border-t-transparent border-b-transparent
            border-l-neutral-400">
          </div>
        </div>
      )}

    </div>
  ))}

</div>

       {/* Page Title */}
            <h1 className="text-2xl font-semibold mb-10">Create an Event</h1>
      <EventTypeSection
        digitalEvent={digitalEvent}
        setDigitalEvent={setDigitalEvent}
        featureEvent={featureEvent}
        setFeatureEvent={setFeatureEvent}
        eventNature={eventNature}
        setEventNature={setEventNature}
        setSelectedCategoryId={setSelectedCategoryId}
      />

      <OrganizerDetails />

      <EventDetails />

<ImageUpload
  images={eventImages}
  setImages={setEventImages}
  title="Upload Images"
  multiple={true}
/>
      <div className="flex justify-end mt-10">
        <button
          type="submit"
          className="bg-green-700 hover:bg-green-800 text-white text-sm font-semibold px-8 py-3 uppercase"
        >
          Save & Continue
        </button>
      </div>

    </form>
  );
}